// removed by extract-text-webpack-plugin
module.exports = {"gridView":"_2FmYO","emptyItemCard":"_2CQan"};